import { Message } from 'element-ui';
import { queryAccountInfo, queryMenu } from '@/service';
/**
 * state(类似存储全局变量的数据)
 * getters(提供用来获取state数据的方法)
 * actions(提供跟后台接口打交道的方法， 并调用mutations提供的方法)
 * mutations(提供存储设置state数据的方法)
 */
let state = {
  account: {},
  menu: [],
  // campaignObj: JSON.parse(sessionStorage.getItem('$campaignObj')) || {},  // 计划
}
let getters = {
  account: state => {
    if (state.account.token) return state.account;
    return JSON.parse(sessionStorage.getItem('$account')) || state.account
  },
  menu: state => state.menu,
  permissions: state => {
    if (state.account.permissions) {
      return state.account.permissions
    } else {
      return JSON.parse(sessionStorage.getItem('$permissions'))
    }
  }
}
let mutations = {
  setAccount(state, val) {
    state.account = val;
    sessionStorage.setItem('$account', JSON.stringify(val));
  },
  updateAccount(state, val) {
    state.account = Object.assign({ ...state.account }, { account: val });
    sessionStorage.setItem('$account', JSON.stringify(state.account));
  },
  setMenu(state, val) {
    state.menu = val;
  }
}
let actions = {
  setAccountAsync(context) {
    queryAccountInfo().then((res) => {
      // console.log(res);
      if (res.code != 200) {
        Message({
          showClose: true,
          message: res.message,
          type: 'error',
          duration: 2 * 1000
        })
        return;
      }
      context.commit('setAccount', res.data);
      sessionStorage.setItem('$permissions', JSON.stringify(res.data.permissions))
    });
  },
  setMenuAsync(context) {
    queryMenu().then((res) => {
      // console.log(res);
      if (res.code != 200) {
        Message({
          showClose: true,
          message: res.message,
          type: 'error',
          duration: 2 * 1000
        })
        return;
      }
      if (res.data && res.data.routers) {
        context.commit('setMenu', res.data.routers);
      }
    });
  },
}
export default {
  namespaced: true, // namespaced 属性，限定命名空间
  state,
  getters,
  mutations,
  actions
}